/**
 * SiteActionCard — Dashboard Build Engine P4 (2026-07-28).
 *
 * Third Business-OS action card: once the tenant has described their business
 * (Q1) — and ideally how they get customers (Q2) — offer to build a simple
 * website by kicking off a Pi routine that uses the existing build + deploy
 * tools (deploy_project et al.). Shared ActionCard + startPiRoutine +
 * buildSiteSeed. §6 (Q1/Q2 → sites → Deploys).
 */
import { Globe } from 'lucide-react';
import { useDashboardStore } from '@/stores/dashboardStore';
import { ActionCard } from './ActionCard';
import { runBuildStep, buildSiteSeed } from './buildEngine';

export function SiteActionCard() {
  const business = useDashboardStore((s) => s.profile.business);
  const customers = useDashboardStore((s) => s.profile.customers);
  const status = useDashboardStore((s) => s.buildState.site);
  const setBuildStepStatus = useDashboardStore((s) => s.setBuildStepStatus);

  // A site needs at least the "business" answer; customers just sharpens it.
  if (!business.trim()) return null;

  return (
    <ActionCard
      testId="site-action-card"
      icon={<Globe className="h-5 w-5" />}
      title="Build your website"
      description="Stand up a simple site for your business and publish it."
      preview={business}
      previewTestId="site-action-preview"
      buttonLabel="Build my website"
      buttonTestId="site-action-start"
      onAction={() => void runBuildStep('site', buildSiteSeed(business, customers))}
      status={status ?? 'todo'}
      onMarkDone={() => void setBuildStepStatus('site', 'done')}
      onReopen={() => void setBuildStepStatus('site', 'todo')}
    />
  );
}

export default SiteActionCard;
